import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { EpcotConfigService } from 'packages/sports/web/app/src/common/epcot-config.service';

@Component({
    selector: 'bs-rewards-not-eligible-info',
    templateUrl: './rewards-not-eligible-info.component.html',
    styleUrls: ['./rewards-not-eligible-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TrustPipe],
})
export class RewardsNotEligibleInfoComponent {
    @Input() message: string;
    readonly isEpcotEnabled = inject(EpcotConfigService).isEnabled();
}
